<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<form>
    <div [ngClass]="rowClass" *ngFor="let row of fieldGrid">

        <div [ngClass]="colClass" *ngFor="let col of row.cols">
            <div [class.align-items-center]="labelDisplay === 'inline' && !colAlignItems"
                     [class.flex-column]="labelDisplay === 'top'"
                     [class.flex-row]="labelDisplay === 'inline'"
                     [class.justify-content-end]="!col.field"
                     [ngClass]="colAlignItems ? colAlignItems : ''"
                     class="d-flex"
                >
                    <div *ngIf="col.field && col.field?.display() !== 'none'"
                         [class.pr-3]="labelDisplay === 'inline'" >
                        <label *ngIf="col.field.label" [ngClass]="labelClass">{{col.field.label}}</label>
                        <scrm-label *ngIf="!col.field.label && col.field.labelKey"
                                    [labelKey]="col.field.labelKey"
                                    [ngClass]="labelClass"></scrm-label>
                    </div>
                    <div *ngIf="col.field && col.field?.display()!== 'none'"
                         [class.flex-grow-1]="labelDisplay === 'inline'">
                        <scrm-field [field]="col.field"
                                    [klass]="inputClass"
                                    [mode]="fieldMode"
                                    [record]="record"
                                    [type]="col.field.type">
                        </scrm-field>
                    </div>
                    <ng-container *ngIf="col.actionSlot">
                        <ng-content select="[field-grid-actions]"></ng-content>
                    </ng-container>
                    <ng-container *ngIf="col.specialSlot">
                        <ng-content select="[field-grid-special]"></ng-content>
                    </ng-container>
                </div>
        </div>
    </div>
</form>
